import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock } from 'lucide-react';
import { useProject } from '@/lib/ProjectContext';
import { useT } from '@/lib/LanguageContext';

export default function Scheduling() {
  const t = useT();
  const { activeProject, loading: projectLoading } = useProject();

  if (projectLoading) {
    return (
      <Layout title={t('scheduling.title')}>
        <div className="flex items-center justify-center h-96">
          <p className="text-[#5C6670]" style={{ fontFamily: 'Manrope' }}>Loading projects...</p>
        </div>
      </Layout>
    );
  }

  if (!activeProject) {
    return (
      <Layout title={t('scheduling.title')}>
        <div className="flex items-center justify-center h-96">
          <div className="text-center space-y-3">
            <p className="text-[#1E2A33] font-semibold" style={{ fontFamily: 'Manrope' }}>No project selected</p>
            <p className="text-[#5C6670] text-sm">Select a project from the sidebar to view scheduling</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Scheduling">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5" />
            Meeting Scheduler
          </CardTitle>
          <CardDescription>
            Book meetings and create Outlook calendar events with Teams links
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <p>Meeting scheduling calendar will be displayed here</p>
            <p className="text-sm mt-2">Integrates with Outlook Calendar and Microsoft Teams</p>
          </div>
        </CardContent>
      </Card>
    </Layout>
  );
}
